<router-outlet />

@if (isDev) {
  <div class="fixed top-[72px] right-4 px-3 py-1 rounded-full text-xs font-semibold shadow-lg z-50 bg-amber-500 text-amber-950">
    DEV
  </div>
}
